var map = {
	"./medium/00-мишка.json": 13,
	"./small/00-смайл.json": 14,
	"./small/01-дельфин.json": 15,
	"./small/02-кораблик.json": 16,
	"./small/03-слоник.json": 17,
	"./small/04-лось.json": 18,
	"./small/05-кошка.json": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;